import type { ThemeSetting } from './tokens';

/**
 * External store for the theme setting. It lets code outside the React tree
 * (e.g. the CLI's settings handler) switch the theme of a running TUI: the
 * ThemeProvider subscribes to it and re-renders on changes.
 */
export interface ThemeController {
  getSetting(): ThemeSetting;
  setSetting(setting: ThemeSetting): void;
  /** Registers a change listener and returns an unsubscribe function. */
  subscribe(listener: () => void): () => void;
}

export const createThemeController = (initialSetting: ThemeSetting = 'auto'): ThemeController => {
  let setting = initialSetting;
  const listeners = new Set<() => void>();

  return {
    getSetting: () => setting,
    setSetting: (next: ThemeSetting) => {
      if (next === setting) return;
      setting = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
